import { ReturnCsvRow } from './return-batch.types';

/** Strict two-column CSV; preserves leading zeros and quoted commas without spreadsheet coercion. */
export function parseReturnCsv(source: string): ReturnCsvRow[] {
  const text = source.replace(/^\uFEFF/, '');
  const records: string[][] = [];
  let cells: string[] = [], cell = '', quoted = false, closedQuote = false;
  const pushCell = (): void => { cells.push(cell.trim()); cell = ''; closedQuote = false; };
  const pushRow = (): void => {
    pushCell();
    if (cells.some((value) => value !== '')) { records.push(cells); }
    cells = [];
    if (records.length > 501) { throw new Error('A batch can contain up to 500 products.'); }
  };
  for (let i = 0; i < text.length; i++) {
    const c = text[i];
    if (quoted) {
      if (c === '"') {
        if (text[i + 1] === '"') { cell += '"'; i++; }
        else { quoted = false; closedQuote = true; }
      } else { cell += c; }
      continue;
    }
    if (c === ',') { pushCell(); }
    else if (c === '\r' || c === '\n') {
      pushRow();
      if (c === '\r' && text[i + 1] === '\n') { i++; }
    } else if (c === '"') {
      if (cell.trim() !== '' || closedQuote) { throw new Error('A CSV quote is in the wrong place.'); }
      cell = ''; quoted = true;
    } else {
      if (closedQuote && c.trim() !== '') { throw new Error('Unexpected text after a CSV quote.'); }
      cell += c;
    }
  }
  if (quoted) { throw new Error('A quoted CSV value was not closed.'); }
  if (cell !== '' || cells.length || closedQuote) { pushRow(); }
  const header = records.shift();
  if (!header || header.length !== 2 || header[0].toLowerCase() !== 'serial_number' || header[1].toLowerCase() !== 'model_number') {
    throw new Error('Use exactly these two headers: serial_number,model_number.');
  }
  if (records.length === 0) { throw new Error('The CSV has no products.'); }
  return records.map((row, index) => {
    if (row.length !== 2 || !row[1] || row.some((value) => value.length > 100 || /[^\x20-\x7E]/.test(value))) {
      throw new Error(`Product row ${index + 1} needs two columns and a model code. Leave the serial blank for nonserialized products.`);
    }
    return { serial_number: row[0], model_number: row[1] };
  });
}
